<template>
    <footer class="footer">
        <div class="container">
        <div class="footer-box">
            <el-row>
            <el-col :span="19">
                <ul>
                <li class="footer-title">常见问题</li>
                <li>
                    <router-link to="/article?id=1">购物流程</router-link>
                </li>
                </ul>
                <ul>
                <li class="footer-title">支付方式</li>
                <li>
                    <router-link to="/article?id=2">购物支付方式</router-link>
                </li>
                </ul>
                <ul>
                <li class="footer-title">购物指南</li>
                <li>
                    <router-link to="/article?id=3">购物指南</router-link>
                </li>
                </ul>
                <ul>
                <li class="footer-title">退款/售后</li>
                <li>
                    <router-link to="/article?id=4">退款/售后流程</router-link>
                </li>
                </ul>
                <div class="clear"></div>
            </el-col>
            <el-col :span="5">
                <div class="footer-title">客服电话/微信同号</div>
                <div class="footer-tel">15520900999</div>
            </el-col>
            </el-row>
        </div>
        <div class="copyright text-center">
            Copyright © 2022-{{getYear}} 马上商城 版权所有 保留一切权利 备案号: <a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备20014711号-3</a>
            <div class="beian">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51110202000389" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/static/images/icons/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">川公网安备 51110202000389号</p></a>
            </div>
        </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data () {
    return {
    }
  },
  computed: {
      getYear () {
          let nowDate = new Date()
          return nowDate.getFullYear()
      }
  }
}
</script>
<style lang="scss" scoped>
    .beian {
        margin: 20px 0 15px 0;
    }
</style>
